import CommonEdit from "@/components/common/Edit"
import VendorForm from "./VendorForm"
import { FC, useEffect, useState } from "react"
import { vendorForm } from "@/utils/objects"
import { singleProp } from "@/interface/dataInterface"
import axiosInstance from "@/utils/axiosInstance"
import { VendorData } from "@/interface/entityInterface"

const VendorsEdit: FC<singleProp> = ({prop}) => {
    const [formProp, setFormProp] = useState(vendorForm)

    useEffect(() => {
        if (!prop) return;
        const getVendorData = async () => {
            const {data} = await axiosInstance.get<VendorData>(`/vendors/${prop}`)
            const {vendor_name, notes} = data
            setFormProp({vendor_name, notes})
        }

        getVendorData()
    }, [prop])

    return (
        <CommonEdit id={prop} title={`Edit vendor #${prop}`} data={formProp} resource="vendors" responseMessage="Vendor updated">
            <VendorForm formProp={formProp} setFormProp={setFormProp} />
        </CommonEdit>
    )
}

export default VendorsEdit